import {
	SET_CURRENT_MAP,
	UPDATE_MAP,
	UPDATE_MAP_SEARCH_LIST,
	SEARCHING_MAPS,
	DONE_SEARCHING_MAPS,
	UPDATE_PLACES,
	SET_PURCHASE_MAP,
	SHOW_PURCHASE_MAP,
	HIDE_PURCHASE_MAP,
	UPDATE_DATE,
	UPDATE_STORM_DATA,
} from 'constants';

const copy = (item) => {
	return JSON.parse(JSON.stringify(item));
}

/* The Map reducers used for anything to do with map component's global state.
* @namespace Maps
* @memberof Reducers
*
*/

export const maps = (state = {
	loading : false,
	array : [],
	currentMap : null,
	current_maps : [],
	showPurchaseMap: false,
	purchaseMap : null,
	places : [], //Current places searched.
	date : null, //Current date being searched.
	stormData: null
}, action) => {
	switch(action.type) {
		case SEARCHING_MAPS:
			return Object.assign({},state,{
				loading : true
			});
		case DONE_SEARCHING_MAPS:
			return Object.assign({},state,{
				loading : false
			});
		case UPDATE_MAP_SEARCH_LIST:
			return Object.assign({},state,{array:action.maps});
		case SET_CURRENT_MAP: case UPDATE_MAP:
			return Object.assign({},state,{
				currentMap : map(state,action)
			});
		case UPDATE_PLACES:
			return Object.assign({},state,{
				places : action.places
			});
		case UPDATE_DATE:
			return Object.assign({},state,{
				date : action.date
			});
		case SET_PURCHASE_MAP:
			return Object.assign({},state, {
				purchaseMap : action.map
			});
		case SHOW_PURCHASE_MAP:
			return Object.assign({},state,{
				showPurchaseMap : true
			})
		case HIDE_PURCHASE_MAP:
			return Object.assign({},state,{
				showPurchaseMap : false
			});
		case UPDATE_STORM_DATA:
			return Object.assign({},state,{
				stormData : action.stormData
			});
		default:
			return state;
	}
}

export const map = (state = {},action) => {
	switch(action.type) {
		case SET_CURRENT_MAP:
			return action.map;
		case UPDATE_MAP:
			return Object.assign({},state,action.map);
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/common/reducers/maps.js